<div class="footer">
  <a target="_blank" href="assets/files/impresszum.pdf"><p>Impresszum</p></a>
  <a target="_blank" href="assets/files/adatkezelesi-tajekoztato.pdf"><p>Adatkezelési tájékoztató</p></a>
  <a target="_blank" href="assets/files/sutikezelesi-tajekoztato.pdf"><p>Sütikezelési tájékoztató</p></a>
</div>
